let categoriesData = [
  {
    "happinessCategoryTipsId": 1,
    "happinessCategoryTipsName": "Categoría 1",
    "status": true,
    "tChanged": "2026-05-13T10:00:00",
    "imageId": 48
  },
  {
    "happinessCategoryTipsId": 2,
    "happinessCategoryTipsName": "Categoría 2",
    "status": true,
    "tChanged": "2026-05-13T10:00:00",
    "imageId": 48
  },
  {
    "happinessCategoryTipsId": 3,
    "happinessCategoryTipsName": "Categoría 3",
    "status": false,
    "tChanged": "2026-05-13T10:00:00",
    "imageId": 48
  }
];

let nextId = 4;

export const service = {
  getTips: () => new Promise(resolve => {
    console.log("Mock: getTips!!!!");
    setTimeout(resolve({ data: categoriesData }), 1000);
  }),
  createTip: (data) => new Promise(resolve => {
    const newCategory = {
      happinessCategoryTipsId: nextId++,
      happinessCategoryTipsName: data.happinessCategoryTipsName,
      status: data.status !== undefined ? data.status : true,
      tChanged: new Date().toISOString(),
      imageId: 48
    };
    categoriesData.push(newCategory);
    setTimeout(resolve({
      data: newCategory,
      status: 200
    }), 1000);
  }),
  updateTip: (data) => new Promise(resolve => {
    const index = categoriesData.findIndex(c => c.happinessCategoryTipsId === data.tipId);
    if (index !== -1) {
      categoriesData[index] = {
        ...categoriesData[index],
        happinessCategoryTipsName: data.happinessCategoryTipsName,
        status: data.status !== undefined ? data.status : true,
        tChanged: new Date().toISOString()
      };
      setTimeout(resolve({
        data: categoriesData[index],
        status: 200
      }), 1000);
    } else {
      setTimeout(resolve({ status: 404 }), 1000);
    }
  }),
  deleteTip: (tipId) => new Promise(resolve => {
    const index = categoriesData.findIndex(c => c.happinessCategoryTipsId === tipId);
    if (index !== -1) {
      categoriesData.splice(index, 1);
      setTimeout(resolve({
        data: "Categoría eliminada correctamente.",
        status: 200
      }), 1000);
    } else {
      setTimeout(resolve({ status: 404 }), 1000);
    }
  })
};
